import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { getClassName, checkButtonDisabled } from '../../utils/forms';
import { storeWithExpiration, getOrderTotalCost, toIdString } from '../../utils/common';

import InputField from '../shared/InputField';
import ConfirmOrderDialog from './ConfirmOrderDialog';
import PriceBookTableContainer from '../pricing/PriceBookTableContainer';

moment.locale('en');
momentLocalizer();

const formats = ['MMM d yyyy', 'MMM d yy', 'd'];

const NON_BILLABLE_REASONS = ['Sandbox', 'Test/Training', 'Other'];

export default class NewOrderFormFive extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    accountSettings: PropTypes.object.isRequired,
    change: PropTypes.func.isRequired,
    closeDialogFunction: PropTypes.func.isRequired,
    createOrderFunction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    escapeForm: PropTypes.func.isRequired,
    formValues: PropTypes.object,
    getPriceBookFunction: PropTypes.func.isRequired,
    getRevShareFunction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    creditsEnabled: PropTypes.bool.isRequired,
    openDialogFunction: PropTypes.func.isRequired,
    previousPageFunction: PropTypes.func.isRequired,
    priceBook: PropTypes.object.isRequired,
    renderCompanyInfo: PropTypes.func.isRequired,
    renderOrderSummaryChunk: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    formValues: undefined,
  };

  componentWillMount = () => {
    const { accountId, getRevShareFunction, getPriceBookFunction } = this.props;

    const token = storeWithExpiration.get('token');

    getPriceBookFunction(accountId, token);
    getRevShareFunction(accountId, token);
  };

  isErrorForOrderTotal = () => {
    let error = false;
    const {
      formValues: { numberOfSeats, platformCode },
    } = this.props;
    const isCRM = platformCode === 'SFDC' || platformCode === 'DYNAMICS';

    if (!isCRM) {
      // Don't validate Number of seats
    } else if (!numberOfSeats || numberOfSeats === '') {
      error = true;
    } else if (Number.isNaN(Number(numberOfSeats))) {
      error = true;
    } else if (Number(numberOfSeats) < 1) {
      error = true;
    } else if (parseInt(numberOfSeats, 10) !== Number(numberOfSeats)) {
      error = true;
    } else if (parseInt(numberOfSeats, 10) > 1000) {
      error = true;
    }
    if (isCRM) {
      // Don't validate Number of records
    }

    return error;
  };

  handleStartDayChange = param => {
    const { change } = this.props;
    const endDayDate = new Date(
      moment(param)
        .add(1, 'Y')
        .format()
    );

    if (endDayDate) {
      change('endDay', endDayDate);
    }
    return change('startDay', new Date(param));
  };

  handleEndDayChange = param => {
    const { change } = this.props;
    return change('endDay', new Date(param));
  };

  // Field manipulation is due to the fact that the calendar picker
  // requires a date object, but react currently doesn't support passing objects as form values
  openConfirmationDialog = () => {
    const { openDialogFunction } = this.props;
    openDialogFunction('confirmOrderDialog');
  };

  renderGenericField = ({ input, label, meta: { touched, error } }) => (
    <div className={`${getClassName(touched, error)} row`}>
      <div className="col-sm-10">
        <label htmlFor={toIdString(label)} className="form-control-label">
          {label} {touched && error && <span> | {error} </span>}
        </label>
        {this.renderSpecialInput(label, input)}
      </div>
    </div>
  );

  renderSpecialInput = (label, input) => {
    if (label === 'Start date') {
      return this.renderDateTimeInput(
        this.handleStartDayChange,
        input.value === null ? null : new Date(input.value),
        typeof input === 'string' ? null : input,
        label
      );
    } else if (label === 'End date') {
      return this.renderDateTimeInput(
        this.handleEndDayChange,
        input.value === null ? null : new Date(input.value),
        typeof input === 'string' ? null : input,
        label
      );
    }
    return null;
  };

  renderDateTimeInput = (changeMethod, value, input, label) => {
    const date = new Date();
    return (
      <div id={toIdString(label)}>
        <DateTimePicker
          value={value}
          selected={input.value ? moment(input.value) : null}
          time={false}
          min={date}
          parse={formats}
          onChange={param => changeMethod(param)}
        />
      </div>
    );
  };

  renderNonBillableInputs = field => {
    const {
      formValues: { billingInfo },
    } = this.props;
    const disable = billingInfo !== 'Other';

    return (
      <div key={field.toLowerCase()} className="radio-inline" id="billingReason">
        <label htmlFor="billingInfo" className="form-control-label">
          <Field id="billingInfo" name="billingInfo" value={field} component="input" type="radio" />{' '}
          {field}
        </label>
        {field === 'Other' ? (
          <Field
            className={disable ? 'text-input disabled' : 'text-input'}
            name="billingInfoOther"
            component="input"
            type="text"
            disabled={disable}
          />
        ) : null}
      </div>
    );
  };

  renderDatasetSettings = () => {
    const {
      formValues: { listId },
    } = this.props;
    const dataset = JSON.parse(listId);

    if (dataset.customType === 'acxiom') {
      // Acxiom-specific order settings
      return (
        <fieldset>
          <div className="card card-block order-card">
            <div className="card-title">
              <p className="card-text">
                <strong>Acxiom API Settings</strong>
              </p>
            </div>
            <div className="form-group">
              <div className="form-group row">
                <div className="col-md-6">
                  <div className="form-group">
                    <Field
                      name="customSettings.acxiom.apiKey"
                      type="text"
                      component={InputField}
                      label="API Key"
                      placeholder="Acxiom API Key"
                    />
                    <Field
                      name="customSettings.acxiom.apiSecret"
                      type="text"
                      component={InputField}
                      label="API Secret"
                      placeholder="Acxiom API Secret"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      );
    }

    return null;
  };

  render() {
    const {
      accountId,
      accountSettings,
      dialog,
      escapeForm,
      formValues: { companyName, platformCode, numberOfSeats, isBillable },
      handleSubmit,
      invalid,
      creditsEnabled,
      priceBook,
      renderOrderSummaryChunk,
      renderCompanyInfo,
      submitting,
      createOrderFunction,
      closeDialogFunction,
      previousPageFunction,
    } = this.props;
    const isCRMTable = platformCode === 'SFDC' || platformCode === 'DYNAMICS';
    const pricebookData = isCRMTable ? priceBook.get('crmList') : null;
    const selectedPbData = pricebookData
      ? pricebookData
          .map(value => ({
            floor: value.get('floor'),
            min: value.get('min'),
            max: value.get('max'),
          }))
          .toArray()
      : null;
    // Only allowing pricing for CRMs at the moment
    const isPricingEnabled =
      isCRMTable && accountSettings ? accountSettings.get('PRICING_ENABLED') : false;

    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body align-items-center">
              <div className="row">
                <div className="col-sm-12">
                  <span className="pull-right">
                    <button
                      type="button"
                      className="btn btn-danger-outline"
                      onClick={() => escapeForm()}
                    >
                      Cancel
                    </button>
                  </span>
                  <h1 className="header-title">Order Terms</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-10">
              <div className="card-border">
                <div className="card-header">
                  <div className="card-header-title">Order Term Configuration</div>
                </div>
                <div className="card-block">
                  {renderCompanyInfo()}
                  <form>
                    {this.renderDatasetSettings()}
                    <fieldset>
                      <div className="card card-block order-card">
                        <div className="card-title">
                          <p className="card-text">
                            <strong>Select Order Terms</strong>
                          </p>
                        </div>
                        <div className="form-group">
                          <div className="form-group row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <Field
                                  name="startDay"
                                  component={this.renderGenericField}
                                  label="Start date"
                                />
                                <Field
                                  name="endDay"
                                  component={this.renderGenericField}
                                  label="End date"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                {creditsEnabled ? (
                                  <Field
                                    name="recordCredits"
                                    type="number"
                                    component={InputField}
                                    label="Prospecting Credits"
                                    placeholder="100,000"
                                  />
                                ) : null}
                                {/* Render numberOfSeats if CRM else render nothing */}
                                {isCRMTable ? (
                                  <Field
                                    name="numberOfSeats"
                                    type="number"
                                    component={InputField}
                                    label="Number of Seats"
                                    placeholder="100"
                                  />
                                ) : null}
                                <label htmlFor="isBillable" className="form-control-label">
                                  Is Order Billable?
                                </label>
                                <div id="isBillable" className="radio-inline">
                                  <label htmlFor="isBillableTrue" className="form-control-label">
                                    <Field
                                      id="isBillableTrue"
                                      name="isBillable"
                                      value="true"
                                      component="input"
                                      type="radio"
                                    />{' '}
                                    Yes
                                  </label>
                                </div>
                                <div className="radio-inline">
                                  <label htmlFor="isBillableFalse" className="form-control-label">
                                    <Field
                                      id="isBillableFalse"
                                      name="isBillable"
                                      value="false"
                                      component="input"
                                      type="radio"
                                    />{' '}
                                    No
                                  </label>
                                </div>
                                {isBillable === 'false' ? (
                                  <div>
                                    <label htmlFor="billingReason" className="form-control-label">
                                      Please declare a reason: <br />
                                    </label>
                                    <br />
                                    {NON_BILLABLE_REASONS.map(this.renderNonBillableInputs)}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <br />
                          <div className="form-group row">
                            <div className="col-md-6">
                              {isPricingEnabled ? (
                                <p>
                                  <strong>
                                    Amount owed Datarista per month:&nbsp;
                                    {!numberOfSeats ||
                                    Number.isNaN(numberOfSeats) ||
                                    selectedPbData === null ||
                                    this.isErrorForOrderTotal()
                                      ? null
                                      : `$${getOrderTotalCost(
                                          numberOfSeats,
                                          selectedPbData,
                                          isCRMTable
                                        )}`}{' '}
                                  </strong>
                                </p>
                              ) : null}
                            </div>
                            <div className="form-buttons col-md-6">
                              <div className="row">
                                <div className="col-sm-10">
                                  <p className="pull-right">
                                    <button
                                      type="button"
                                      className="btn btn-secondary btn-back"
                                      onClick={previousPageFunction}
                                    >
                                      Back
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={this.openConfirmationDialog}
                                      disabled={checkButtonDisabled(invalid, submitting)}
                                    >
                                      Place Order
                                    </button>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                  {isPricingEnabled ? (
                    <PriceBookTableContainer
                      accountId={accountId}
                      dialog={dialog}
                      isSuperAdmin={false}
                      isCRM={isCRMTable}
                      tableContents={
                        isCRMTable ? priceBook.get('crmList') : priceBook.get('maList')
                      }
                      revShare={priceBook.get('revShare')}
                      resetForm={() => {}}
                      openDialogFunction={() => {}}
                      closeDialogFunction={() => {}}
                      updatePriceAction={() => {}}
                    />
                  ) : null}
                </div>
                {dialog.id === 'confirmOrderDialog' && dialog.show ? (
                  <ConfirmOrderDialog
                    companyName={companyName}
                    dialog={dialog}
                    handleSubmit={handleSubmit}
                    selectedPbData={selectedPbData}
                    renderOrderSummaryChunk={renderOrderSummaryChunk}
                    closeDialogFunction={closeDialogFunction}
                    createOrderFunction={createOrderFunction}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
